var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKiosk = function SvgKiosk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M12.727 27.628h-3.92V1.963H20.16v14.458m-11.354 1.49h3.932"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M15.006 28.037v-1.47l-1.96-2.83v-2.812a1 1 0 0 1 .552-.894l1.408-.704h0v-4.956c0-.58.272-1.127.735-1.478a1.22 1.22 0 0 1 1.47 0c.463.35.735.898.735 1.478v4.356h0l4.096.819a1 1 0 0 1 .804.98v4.191h0l-.98 1.85v1.47m-6.861-8.71v2.83"
  }))));
};
export default SvgKiosk;